'use strict';

var _ = require('lodash');
function DemandManagementController($scope, reoptimizationService, marketGridsDataService, reoptPreviewDataUtilsService) {
  $scope.onSelectFlights = function (selectedCabins) {
    if (reoptPreviewDataUtilsService.shouldUndoMdReopt($scope.reoptPreviewData, selectedCabins)) {
      reoptimizationService.undoMdReoptAndReload($scope.reoptPreviewData);
      return;
    }
    $scope.demandManagementData = marketGridsDataService.prepareDemandManagementData({
      cabin: selectedCabins
    });
  };
}
DemandManagementController.$inject = ['$scope', 'ReoptimizationService', 'MarketGridsDataService', 'ReoptPreviewDataUtilsService'];
module.exports = DemandManagementController;